module.exports = __webpack_public_path__ + "img/qrcode_back.54497e4a.png";